import React from "react";
import _, { isEmpty } from "lodash";
import { push } from "react-router-redux";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  DataTable,
  SearchPropTypes,
  PartNumber,
  CompanyName,
  LocationFlag,
  NoteTooltip
} from "MODULES/shared/components";
import { shortDate } from "LIB/formatters/date";
import { ExchangeIcon } from "MODULES/SalesOrders/helpers";
import MultiLocationFeature from "MODULES/shared/components/MultiLocationFeature/MultiLocationFeature";
import { CONDITION_TYPES, RECORD_TYPES } from "../constants";

const buildLink = ({
  parent_type: parentType,
  parent_id: parentId,
  type,
  uuid,
  id
}) => {
  if (type === "rma") {
    return `/rmas/${uuid || id}`;
  }
  return `/${parentType.replaceAll("_", "-")}/${uuid || parentId}`;
};

function renderRow(r, openModal, virtual) {
  const qtyOrdered = r.quantity || 0;
  const qtyReceived = r.quantity_received || 0;
  const qtyUnreceived = qtyOrdered - qtyReceived;

  return (
    <tr key={r.id} className="clickable" onClick={() => openModal(r)}>
      <td>
        <Link to={buildLink(r)}>{r.reference_number}</Link>
      </td>
      <td>{shortDate(r.created_at)}</td>
      <td>
        <PartNumber
          part={{
            id: r.part.part_uuid,
            part_number: r.part_number
          }}
          statsTooltip={false}
        />
      </td>
      <td>
        {r.serial_number ? (
          <Link to={`/inventories/${r.inventory_id}`}>{r.serial_number}</Link>
        ) : (
          r.expected_serial_number
        )}
      </td>
      <td>
        {r.mod_to_id && <PartNumber part={r.mod_to} statsTooltip={false} />}
      </td>
      <MultiLocationFeature>
        <td>
          <LocationFlag location={_.get(r, "store.id")} />
        </td>
      </MultiLocationFeature>
      {virtual && <td>{r.type && RECORD_TYPES[r.type].label}</td>}
      <td>
        <CompanyName company={r.company} statsTooltip={false} truncateAt={25} />
      </td>
      <td>{r.awb_number}</td>
      <td>{_.get(CONDITION_TYPES, `${r.condition}.label`)}</td>
      {!virtual && (
        <td className="text-center">
          {r.exchange_sale && <ExchangeIcon lineItem={r} />}
        </td>
      )}
      <td className="text-center">{qtyUnreceived}</td>
      <td className="text-center">{qtyOrdered}</td>
      <td className="text-center" style={{ position: "relative" }}>
        {qtyReceived}
        {!isEmpty(r.receiving_cached_key) && (
          <span style={{ position: "absolute", right: "10px" }}>
            <NoteTooltip
              note="Saved Checklist"
              icon="fa-thumb-tack"
              color="#2196F3"
            />
          </span>
        )}
      </td>
    </tr>
  );
}

export function Table({ openModal, isLoading, pageActions, results, virtual }) {
  return (
    <DataTable loading={isLoading} refresh={pageActions.expire}>
      <DataTable.Head>
        <th>Ref #</th>
        <th>Date Created</th>
        <th>Part #</th>
        <th>Serial #</th>
        <th>Mod To #</th>
        <MultiLocationFeature>
          <th>Store Owner</th>
        </MultiLocationFeature>
        {virtual && <th>Type</th>}
        <th>Company</th>
        <th>AWB #</th>
        <th>Condition</th>
        {!virtual && <th className="text-center">Exch Sale</th>}
        <th className="text-center">QTY Exp</th>
        <th className="text-center">QTY Ord</th>
        <th className="text-center">QTY Rec</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(r => renderRow(r, openModal, virtual))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  openModal: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Dashboard/Table.jsx